import { CheckoutCustomerAddressDetails } from './checkout-customer-address-details.interface';

export interface CheckoutCustomerDetails {
  address: CheckoutCustomerAddressDetails;
  title: string;
  firstName: string;
  lastName: string;
  personId: string;
}
